/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export async function uploadImg(params) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}

export const invite_homepage = createAsyncThunk(
  'InviteFission/invite_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/invite_homepage',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const bind_invite_new_user = createAsyncThunk(
  'InviteFission/bind_invite_new_user',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/bind_invite_new_user',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_invite_user_info = createAsyncThunk(
  'InviteFission/get_invite_user_info',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/misc/get_invite_user_info',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  home: any
  bindInfo: any
}

const initialState: InitialStateType = {
  home: {},
  bindInfo: {},
}

export const InviteFissionSlice = createSlice({
  name: 'InviteFission',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(invite_homepage.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
    builder.addCase(get_invite_user_info.fulfilled, (state, action) => {
      Object.assign(state.bindInfo, action.payload)
    })
  },
})
export default InviteFissionSlice.reducer
export const InviteFissionActions = InviteFissionSlice.actions

export const useInviteFissionState = () =>
  useSelector((store) => store.InviteFission) as InitialStateType
